<template>
  <el-dialog :visible.sync="showModal" @closed="$emit('close')" :width="'60%'">
    <div class="row" slot="title" style="border-bottom: 1px solid #dddddd">
      <div class="col-12">
        <div class="p-2 my-auto d-flex justify-content-between">
          <h4 class="m-0">Ottley Portal Access</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <strong>{{ business.name }}</strong>
      </div>
      <div class="col-md-12">
        <el-table :data="guarantors" style="width: 100%" cell-class-name="py-1">
          <el-table-column
            label="First Name"
            prop="first_name"
          ></el-table-column>
          <el-table-column label="Last Name" prop="last_name"></el-table-column>
          <el-table-column label="Phone" prop="phone"></el-table-column>
          <el-table-column label="Email" prop="email"></el-table-column>
          <el-table-column label="" prop="id">
            <template slot-scope="scope">
              <span class="user-status-badge inactive" v-if="!scope.row.active"
                >Inactive</span
              >
              <el-button
                v-else-if="
                  scope.row.active && scope.row.user_businesses.length == 0
                "
                plain
                class="action-btn fa-sm rounded bg-patina text-white text-uppercase"
                style="padding: 4px 10x; width: 130px"
                @click="accessRequest(scope.row)"
                :loading="scope.row.loading_grant_access"
                >Request Access</el-button
              >
              <div v-else-if="scope.row.user_businesses.length > 0">
                <span
                  v-if="scope.row.user_businesses[0].status_id == 1"
                  class="user-status-badge requested text-uppercase"
                  >Requested</span
                >
                <span
                  v-if="scope.row.user_businesses[0].status_id == 2"
                  class="user-status-badge granted text-uppercase"
                  >Granted</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Guarantor from "../../../modelsPortal/Guarantor";
import Business from "../../../modelsPortal/Business";
export default {
  props: {
    initial_business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      showModal: true,
      business: this.initial_business,
      guarantors: [],
    };
  },
  computed: {},
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      this.loading = true;
      console.log(this.initial_business.id);
      let guarantors = new Guarantor()
        .for(new Business(this.initial_business))
        .select("id", "email", "phone", "first_name", "last_name", "active")
        .append("full_name")
        .include("userBusinesses")
        .params({ no_paginate: true })
        .orderBy("-id");

      guarantors
        .get()
        .then((res) => {
          this.loading = false;
          this.guarantors = res;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    accessRequest: function (guarantor) {
      this.$confirm("Confirm access request for this contact", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        axios
          .put(
            `/api/v2/portal/businesses/${this.initial_business.id}/guarantors/${guarantor.id}/access-request`,
          )
          .then((res) => {
            this.$message({
              type: "success",
              message: "Access requested",
            });
            this.getData();
          })
          .catch((err) => {
            if (err.response.data.message) {
              this.$message({
                type: "error",
                message: err.response.data.message,
              });
            } else {
              this.$message({
                type: "error",
                message: "Looks like something went wrong.",
              });
            }
          });
      });
    },
  },
};
</script>
<style>
.is-active > span {
  color: #000 !important;
}
</style>
